<template lang="pug">
.container-fluid
	.row
		.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
			.card
				.card-header.bg-info.text-white
					.row
						.col
							font-awesome-icon.mr-2(icon="bug")
							span Pendientes
						.col.text-right
							button.btn.btn-sm.btn-warning(
								@click="setNueva"
								style="position: absolute;display: block;right: 10px; top: -2px;"
							)
								span.fa.fa-plus.mr-2
								span Nueva
				Solicitud(
					v-for="solicitud of solicitudesPendientes"
					:key="solicitud.solicitudID"
					:solicitud="solicitud"
					@ver="verSolicitud(solicitud)"
				)
		.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
			.card
				.card-header.bg-danger.text-white
					font-awesome-icon.mr-2(icon="spinner")
					span En curso
				Solicitud(
					v-for="solicitud of solicitudesRealizadas"
					:key="solicitud.solicitudID"
					:solicitud="solicitud"
					@ver="verSolicitud(solicitud)"
				)
		.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
			.card
				.card-header.bg-success.text-white
					span.fa.fa-check-square.mr-2
					span Finalizadas
				Solicitud(
					v-for="solicitud of solicitudesFinalizadas"
					:key="solicitud.SolicitudID"
					:solicitud="solicitud"
					@ver="verSolicitud(solicitud)"
				)
	Editor(
		v-if="EditarID"
		:SolicitudID="EditarID"
		@actualizar="buscar()"
		@cerrar="EditarID = null"
	)

	SolicitudDetalle(
		v-if="SolicitudID"
		:SolicitudID="SolicitudID"
		@cerrar="$router.push('/main/produccion-audiovisual')"
		@actualizar="buscar()"
		@editar="EditarID = $event"
	)
</template>

<script>
import Editor from './nueva'
import SolicitudDetalle from './solicitudDetalle'
import Solicitud from './solicitud'
import axios from 'axios'

/* import { library } from '@fortawesome/fontawesome-svg-core'
import { faGhost, faBug, faSpinner } from '@fortawesome/free-solid-svg-icons'
library.add(faGhost, faBug, faSpinner) */

export default {
	components: {
		Solicitud,
		SolicitudDetalle,
		Editor
	},
	data () {
		return {
			solicitudes: [],
			intervalo: null,
			SolicitudID: null,
			EditarID: null
		}
	},
	created () {
		this.buscar()
		this.intervalo = window.setInterval(() => {
			this.buscar()
		}, 10000)

		if (this.$route.params.SolicitudID) {
			this.SolicitudID = this.$route.params.SolicitudID
		}
	},
	watch: {
		'$route.params': function (newVal) {
			if (newVal.SolicitudID) {
				this.SolicitudID = newVal.SolicitudID
			} else {
				this.SolicitudID = null
			}
		}
	},
	beforeDestroy () {
		window.clearInterval(this.intervalo)
	},
	computed: {
		solicitudesPendientes () {
			return this.solicitudes.filter(s => (!s.FechaEnCurso))
		},
		solicitudesRealizadas () {
			return this.solicitudes.filter(s => (!s.FechaFinalizada))
		},
		solicitudesFinalizadas () {
			return this.solicitudes.filter(s => (s.FechaFinalizada))
		}
	},
	methods: {
		setNueva () {
			this.EditarID = 'nueva'
		},
		buscar () {
			axios.get('solicitudes/php/api/getSolicitudes.php')
				.then(res => {
					this.solicitudes = res.data
				})
				.catch(e => {
					console.error(e)
				})
		},
		verSolicitud (solicitud) {
			this.$router.push('/main/solicitudes/solicitud/' + solicitud.SolicitudID)
			// this.TareaID = tarea.TareaID
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/modulos/solicitudes/vue/components/tablero.vue